import { MMW_URL } from "assets/constant";
import { loadingLottie } from "assets/lottie";
import { white } from "assets/styleUtils";
import Lottie from "lottie-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./style.module.css";

export default function EventReservation() {
  const [showImage, setShowImage] = useState(false);
  const [showCode, setShowCode] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const timer1 = setTimeout(() => {
      setShowImage(true);
    }, 200);
    const timer2 = setTimeout(() => {
      setShowCode(true);
    }, 500);
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  return (
    <div>
      {showImage ? (
        <div className={styles.wrap}>
          <img
            src="/images/venue_1.png"
            alt="venue"
            style={{ width: "100%" }}
          />
          <img
            src="/images/venue_2.png"
            alt="venue"
            style={{ width: "100%" }}
          />
          {showCode ? (
            <div style={{ padding: "0 30px" }}>
              <div className={styles.kakaoBox}>
                <div className={styles.iconDisplay}>
                  <img src="/images/cashback_icon.png" alt="캐시백 아이콘" />

                  <div>
                    최대 15만원 지급!
                    <br />
                    <b>캐시백 이벤트</b>
                  </div>
                </div>
                <button
                  className={styles.clickBox}
                  onClick={() => navigate("/banner/eventcashback")}
                >
                  보러가기
                </button>
              </div>
              <div className={styles.kakaoBox}>
                <div className={styles.iconDisplay}>
                  <img src="/images/coffeeIcon.png" alt="커피 아이콘" />

                  <div>
                    상담 후기 작성자 전원 증정
                    <br />
                    <b>커피 쿠폰 이벤트</b>
                  </div>
                </div>
                <button
                  className={styles.clickBox}
                  onClick={() => navigate("/banner/eventimage")}
                >
                  보러가기
                </button>
              </div>
              <div className={styles.kakaoBox}>
                <div className={styles.iconDisplay}>
                  <img src="/images/hotelIcon.png" alt="호텔 아이콘" />

                  <div>
                    롯데호텔, 시그니엘 등
                    <br />
                    <b>5성급 호텔웨딩</b>
                  </div>
                </div>
                <button
                  onClick={() => navigate("/banner/eventhotelimage")}
                  className={styles.clickBox}
                >
                  예약하기
                </button>
              </div>
              <div className={styles.kakaoBox}>
                <div className={styles.iconDisplay}>
                  <img
                    src="/images/ReferralsIcon.png"
                    alt="추천인 아이콘"
                    style={{ width: "50px", height: "50px" }}
                  />

                  <div>
                    친구가 상담만해도 <br /> 포인트 증정!
                    <br />
                    <b>추천인 이벤트</b>
                  </div>
                </div>
                <button
                  className={styles.clickBox}
                  onClick={() => navigate("/banner/eventReferral")}
                >
                  보러가기
                </button>
              </div>
              <div
                style={{
                  height: "20px",
                  backgroundColor: "#69c0b9",
                }}
              />
            </div>
          ) : null}
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "90vh",
            padding: 50,
          }}
        >
          <Lottie animationData={loadingLottie} loop={true} />
        </div>
      )}
    </div>
  );
}
